import BookingsPage from "views/Booking";
import EditBookingPage from "views/Booking/EditBooking";
import AddCategory from "views/ExperienceCategory/AddCategory";
import AddSubCategory from "views/ExperienceCategory/AddSubCategory";
import AllCategory from "views/ExperienceCategory/AllCategory";
import AllSubCategory from "views/ExperienceCategory/AllSubCategory";
import EditCategory from "views/ExperienceCategory/EditCategory";
import ExperienceDetails from "views/ExperienceDetails";
import FeedbackPage from "views/Feedback";
import Index from "views/Index.js";
import Listing from "views/Listing";
import EditExperience from "views/Listing/editExperience";
// import Profile from "views/Profile.js";
import Login from "views/Login.js";
import ProfileUpdatePage from "views/Profile";
import AddEditSubAdmin from "views/SubAdmin/AddAdmin";
import AllSubAdmins from "views/SubAdmin/AllAdmins";
import SupportPage from "views/Support";
import EditSupportPage from "views/Support/EditSupport";
import TermsAndConditionsPage from "views/TermsAndConditions";
import UsersLists from "views/Users";
import EditUser from "views/Users/EditUser";
import ViewUser from "views/Users/ViewUser";
import BuddyList from "views/Buddy/BuddyList";
import TagRequest from "views/ExperienceCategory/TagRequest";

import InvestorRelation from "views/Forms/investor_relation";
import Partnership from "views/Forms/partnership";
import Community from "views/Forms/community";
import FoundingBuddy from "views/Forms/founding_buddy";
import Career from "views/Forms/career";
import SeekerNetwork from "views/Forms/seeker_network";

var routes = [
  {
    path: "/index",
    name: "dashboard",
    show: "Dashboard",
    icon: "ni ni-tv-2 text-black",
    component: <Index />,
    layout: "/admin",
    IsVisible: true,
  },
  {
    path: "/users",
    name: "user",
    show: "Users",
    icon: "fa-solid fa-user-group text-black",
    component: <UsersLists />,
    layout: "/admin",
    IsVisible: true,
  },
  {
    path: "/buddy",
    name: "buddy",
    show: "Buddy",
    icon: "ri-shield-user-fill text-md text-black",
    component: <BuddyList />,
    layout: "/admin",
    IsVisible: true,
  },
  {
    path: "/listings",
    name: "listing",
    show: "Experiences",
    icon: "fa-solid fa-list-ul text-black",
    component: <Listing />,
    layout: "/admin",
    IsVisible: true,
  },
  {
    path: "/bookings",
    name: "bookings",
    show: "Bookings",
    icon: "fa-solid fa-bag-shopping text-black",
    component: <BookingsPage />,
    layout: "/admin",
    IsVisible: true,
  },
  {
    path: "/bookings/view/:id",
    component: <EditBookingPage edit={false} />,
    layout: "/admin",
    IsVisible: false,
  },
  {
    path: "/bookings/view/:id",
    component: <EditBookingPage edit={false} />,
    layout: "/admin",
    IsVisible: false,
  },
  {
    path: "/bookings/edit/:id",
    component: <EditBookingPage edit={true} />,
    layout: "/admin",
    IsVisible: false,
  },
  {
    path: "/subAdmin",
    name: "subAdmin",
    show: "Sub Admin",
    icon: "fa-solid fa-hand text-black",
    component: <Index />,
    layout: "/admin",
    IsVisible: true,
    children: [
      {
        path: "/sub-admin/all",
        name: "All Sub Admins",
        icon: "fa-solid fa-grip text-primary",
        component: <AllSubAdmins />,
        layout: "/admin",
        IsVisible: true,
      },
      {
        path: "/sub-admin/add",
        name: "Add Sub Admin",
        icon: "fa-solid fa-add text-black",
        component: <AddEditSubAdmin />,
        layout: "/admin",
        IsVisible: true,
      },
    ],
  },
  {
    path: "/profile",
    name: "profile",
    show: "Profile",
    icon: "fa-solid fa-id-badge text-black",
    component: <ProfileUpdatePage />,
    layout: "/admin",
    IsVisible: false,
  },
  // {
  //   path: "/faq",
  //   name: "FAQ",
  //   icon:"fa-solid fa-bars-progress text-black",
  //   component: <Clientms />,
  //   layout: "/admin",
  //   IsVisible: false,
  // },
  {
    path: "/terms-and-conditions",
    name: "terms",
    show: "Terms & Conditions",
    icon: "fa-solid fa-bars-progress text-black",
    component: <TermsAndConditionsPage />,
    layout: "/admin",
    IsVisible: true,
  },
  {
    path: "/review",
    name: "review",
    show: "Review List",
    icon: "fa-solid fa-comment text-black",
    component: <FeedbackPage />,
    layout: "/admin",
    IsVisible: true,
  },
  {
    path: "/support",
    name: "support",
    show: "Support",
    icon: "fa-solid fa-circle-info text-black",
    component: <SupportPage />,
    layout: "/admin",
    IsVisible: true,
  },
  {
    path: "/experience-categorie",
    name: "experienceCategory",
    show: "Experience tags ",
    icon: "fa-solid fa-layer-group text-black",
    component: <Index />,
    layout: "/admin",
    IsVisible: true,
    children: [
      {
        path: "/experience-tag-request",
        name: "Request Tags",
        icon: "fa-solid fa-tag text-black",
        component: <TagRequest/>,
        layout: "/admin",
        IsVisible: true,
      },
      {
        path: "/experience-categories/add",
        name: "Add Experience tags",
        icon: "fa-solid fa-add text-black",
        component: <AddCategory />,
        layout: "/admin",
        IsVisible: true,
      },
      {
        path: "/experience-categories",
        name: "All Experience tags",
        icon: "fa-solid fa-grip text-black",
        component: <AllCategory />,
        layout: "/admin",
        IsVisible: true,
      },
      {
        path: "/add-sub-categories",
        name: "Add Sub tags",
        icon: "fa-solid fa-add text-black",
        component: <AddSubCategory />,
        layout: "/admin",
        IsVisible: true,
      },
      {
        path: "/all-sub-categories",
        name: "All Sub tags",
        icon: "fa-solid fa-grip text-black",
        component: <AllSubCategory />,
        layout: "/admin",
        IsVisible: true,
      },
    ],
  },
  {
    path: "/reports",
    name: "report",
    show: "Reports",
    icon: "fa-solid fa-file text-black",
    component: <Index />,
    layout: "/admin",
    IsVisible: true,
    children: [
      {
        path: "/income-report",
        name: "Income Report",
        icon: "fa-solid fa-file text-black",
        component: <Index />,
        layout: "/admin",
        IsVisible: true,
      },
      {
        path: "/booking-report",
        name: "Booking Report",
        icon: "fa-solid fa-file text-black",
        component: <Index />,
        layout: "/admin",
        IsVisible: true,
      },
    ],
  },
  {
    path: "/forms",
    name: "forms",
    show: "Other Forms",
    icon: "fa-solid fa-file text-black",
    layout: "/admin",
    IsVisible: true,
    children: [
      {
        path: "/seeker_network",
        name: "Seeker Network",
        icon: "fa-solid fa-file text-black",
        component: <SeekerNetwork />,
        layout: "/admin",
        IsVisible: true,
      },
      {
        path: "/career",
        name: "Career",
        icon: "fa-solid fa-file text-black",
        component: <Career />,
        layout: "/admin",
        IsVisible: true,
      },
      {
        path: "/founding_buddy",
        name: "Founding buddy",
        icon: "fa-solid fa-file text-black",
        component: <FoundingBuddy />,
        layout: "/admin",
        IsVisible: true,
      },
      {
        path: "/community",
        name: "Community",
        icon: "fa-solid fa-file text-black",
        component: <Community />,
        layout: "/admin",
        IsVisible: true,
      },
      {
        path: "/partnership",
        name: "Partnership",
        icon: "fa-solid fa-file text-black",
        component: <Partnership />,
        layout: "/admin",
        IsVisible: true,
      },
      {
        path: "/investor_relation",
        name: "Investor relation",
        icon: "fa-solid fa-file text-black",
        component: <InvestorRelation />,
        layout: "/admin",
        IsVisible: true,
      },
    ],
  },
  {
    path: "/edit-experience-categories/:id",
    component: <EditCategory />,
    layout: "/admin",
    IsVisible: false,
  },
  {
    path: "/listings/experience-details/:id",
    component: <ExperienceDetails edit={false} />,
    layout: "/admin",
    IsVisible: false,
  },
  {
    path: "/listings/edit-experience-details/:id",
    component: <EditExperience edit={true} />,
    layout: "/admin",
    IsVisible: false,
  },
  {
    path: "/support/edit/:id",
    component: <EditSupportPage />,
    layout: "/admin",
    IsVisible: false,
  },
  {
    path: "/sub-admin/edit/:id",
    component: <AddEditSubAdmin />,
    layout: "/admin",
    IsVisible: false,
  },
  {
    path: "/user/edit/:id",
    component: <EditUser />,
    layout: "/admin",
    IsVisible: false,
  },
  {
    path: "/user/view/:id",
    component: <ViewUser />,
    layout: "/admin",
    IsVisible: false,
  },

  {
    path: "/login",
    name: "Login",
    icon: "ni ni-key-25 text-black",
    component: <Login />,
    layout: "/auth",
    IsVisible: false,
  },
];
export default routes;
